// extracted by mini-css-extract-plugin
export default {"cvError":"E--z"};